<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2024-06-28 10:02:33
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-11-13 15:02:50
 * @FilePath: /wemeet-admin-new/src/views/data/index.vue
 * @Description:
 * Copyright (c) 2024 by WeMeet, All Rights Reserved.
-->
<template>
  <div ref="containerRef" class="exhDataDialog">
    <questionaireAnalysisVue
      default-identity="EXHIBITOR"
      :idenity-count="idenityCount"
      :now-time="nowTime"
      :questionnaire="questionnaire"
      @identityChangeQuestion="identityChangeQuestion"
    />
  </div>
</template>

<script>
  import { defineComponent, onMounted, reactive, toRefs, onUnmounted, getCurrentInstance } from 'vue'
  import aiAnalysisVue from './components/aiAnalysis.vue'
  import aiTrendAnalysisVue from './components/aiTrendAnalysis.vue'
  import channelAnalysisVue from './components/channelAnalysis.vue'
  import channelDetailVue from './components/channelDetail.vue'
  import dataScreenVue from './components/dataScreen.vue'
  import exhibitiorAndExhibitiVue from './components/exhibitiorAndExhibiti.vue'
  import geoDistributionVue from './components/geoDistribution.vue'
  import questionaireAnalysisVue from './components/questionaireAnalysis.vue'
  import realTimeDataVue from './components/realTimeData.vue'
  import trendAnalysisVue from './components/trendAnalysis.vue'
  import userInteractionVue from './components/userInteraction.vue'
  import userPieVue from './components/userPie.vue'
  import exportRegisterVue from './components/exportRegister.vue'
  import {
    reportMeetingStatistics,
    reportMeetingTrendAnalysis,
    reportMeetingIdentity,
    reportMeetingRealName,
    reportMeetingRegional,
    reportMeetingQuestionnaire,
    reportMeetingaiAgentData,
    reportMeetingChannelCharts,
    reportMeetingChannelList,
  } from '@/api/workBench'
  import { parseTime } from '@/utils/index'
  import { getRegisterConfigList } from '@/api/exhibitionManage'
  export default defineComponent({
    name: 'DataIndex',
    components: {
      realTimeDataVue,
      dataScreenVue,
      userInteractionVue,
      exhibitiorAndExhibitiVue,
      trendAnalysisVue,
      userPieVue,
      geoDistributionVue,
      questionaireAnalysisVue,
      channelAnalysisVue,
      channelDetailVue,
      aiAnalysisVue,
      aiTrendAnalysisVue,
      exportRegisterVue,
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        activeName: 'part4',
        containerRef: null,
        queryForm: {
          meetingCode: 'EX1920026354275885056',
          meetingType: 'EXHIBITION',
          identity: '',
          startTime: '',
          endTime: '',
        },
        todayDate: {
          todayMeetingSignInNum: 0, //当天签到人数
          todayMeetingSignUpNum: 0, //当天报名人数
          todayPageVisitTimes: 0, //当天访问次数
          todayUserVisitNum: 0, //当天访问人数
        },
        dataScreen: {
          userVisitNum: 0, //访问人数
          pageVisitTimes: 0, //访问次数
          meetingSignUpNum: 0, //报名人数
          meetingApprovedNum: 0, //会议已审核人数
          meetingSignInNum: 0, //签到人数
          meetingApprovedNumProportion: 0, // 审核人数占比
          meetingSignInNumProportion: 0, // 签到人数占比
        },
        userInteraction: {
          articleReadTimes: 0, //文章阅读数
          meetingForumVisitTimes: 0, //论坛访问数
          followNum: 0, //关注数
          collectNum: 0, //收藏数
          shareNum: 0, //分享数
          askNum: 0, //提问数
          fileVisitTimes: 0, //文件查看次数
          fileDownloadTimes: 0, //文件下载次数
        },
        queryFormByTrend: {
          endTime: '',
          meetingCode: 'EX1920026354275885056',
          meetingType: 'EXHIBITION',
          startTime: '',
        },

        trendAnalysis: null,
        data: [],
        identity: [],
        realData: [],
        geoDistribution: {},
        questionnaire: [],
        idenityCount: [],
        aiData: {},
        channelData: [],
        channelCodeList: [],
        exportRegisterRef: null,
        nowTime: '',
      })

      const handleClick = (e) => {
        console.log(e.props.name)
        scrollBottom(e.props.name)
      }
      const scrollBottom = (id) => {
        setTimeout(() => {
          if (state.containerRef) {
            const dom = document.getElementById(id)
            console.log(dom, dom.offsetTop)
            state.containerRef.scrollTo({
              top: dom.offsetTop,
              behavior: 'smooth',
            })
          }
        }, 200)
      }

      const queryStaticData = async () => {
        const { data } = await reportMeetingStatistics(state.queryForm)
        state.data = data
        const { data: idenityCount } = await getRegisterConfigList(state.queryForm.meetingCode)
        state.idenityCount = idenityCount
        state.queryForm.identity = idenityCount && idenityCount.length > 0 ? idenityCount[0].identity : ''
        const { data: identity } = await reportMeetingIdentity(state.queryForm)
        identity.forEach((item) => {
          item.name = idenityCount.filter((v) => v.identity == item.label)[0].identityName
        })
        state.identity = identity

        const { data: realData } = await reportMeetingRealName(state.queryForm)
        state.realData = realData

        const { data: regionData } = await reportMeetingRegional(state.queryForm)
        state.geoDistribution = regionData

        const { data: channelCodeList } = await reportMeetingChannelList(state.queryForm)
        state.channelCodeList = channelCodeList
        state.nowTime = parseTime(new Date())
      }

      const queryTrendData = async () => {
        const { data } = await reportMeetingTrendAnalysis(state.queryFormByTrend)
        state.trendAnalysis = data
      }

      const queryQuestionnaire = async () => {
        const { data } = await reportMeetingQuestionnaire(state.queryForm)
        state.questionnaire = data
      }

      const queryAiData = async () => {
        const { data } = await reportMeetingaiAgentData(state.queryForm)
        state.aiData = data
      }

      const queryChannelData = async () => {
        const { data: channelData } = await reportMeetingChannelCharts(state.queryForm)
        state.channelData = channelData
      }

      onMounted(async () => {
        await queryStaticData()
        queryTrendData()
        queryAiData()
        queryChannelData()
        queryQuestionnaire()
      })

      onUnmounted(() => {})

      const changeTrends = (val) => {
        console.log(val, 'emit 触发')
        // 格式化时间
        state.queryFormByTrend.startTime = parseTime(val[0], '{y}-{m}-{d}')
        state.queryFormByTrend.endTime = parseTime(val[1], '{y}-{m}-{d}')
        queryTrendData()
      }

      const changeChannel = (val) => {
        state.queryForm.startTime = parseTime(val[0], '{y}-{m}-{d}')
        state.queryForm.endTime = parseTime(val[1], '{y}-{m}-{d}')
        queryChannelData()
      }

      const changeAiTrends = (val) => {
        state.queryForm.startTime = parseTime(val[0], '{y}-{m}-{d}')
        state.queryForm.endTime = parseTime(val[1], '{y}-{m}-{d}')
        queryAiData()
      }

      const identityChangeQuestion = (val) => {
        state.queryForm.identity = val
        queryQuestionnaire(state.queryForm)
      }

      const exportRegister = (condition) => {
        state.exportRegisterRef.handleOpen(
          {
            code: state.queryForm.meetingCode,
            relationType: state.queryForm.meetingType,
          },
          `渠道报表导出`,
          `MEETING_CHANNEL_STATISTICS_REPORT`,
          condition
        )
      }

      return {
        ...toRefs(state),
        handleClick,
        changeTrends,
        identityChangeQuestion,
        changeAiTrends,
        changeChannel,
        exportRegister,
      }
    },
  })
</script>

<style lang="scss">
  .exhDataDialog {
    .el-tabs__item {
      font-size: 18px;
    }
  }
</style>

<style lang="scss" scoped>
  .exhDataDialog {
    width: 100%;
    height: 83vh;
    background: #f7f8fa;
    overflow-y: auto;
    position: relative;

    .demo-tabs {
      background: #fff;
      border-radius: 10px;
      padding-left: 20px;
    }

    .title {
      font-size: 18px;
      color: #1d2129;
      font-weight: bold;
      margin-bottom: 12px;
    }

    .mt-10 {
      margin-top: 10px;
    }
  }
</style>
